import { FC } from 'react'
import { useNavigate } from '@tanstack/react-router'
import cn from 'classnames'
import { PlaceholderCell } from 'components/extend/PlaceholderCell'
import { getFormattedPriceWithRouble } from 'helpers/string'
import {
  formatCargoSizeSeparate,
  formatCargoVolume,
  formatCargoWeightGramToKilogram
} from 'modules/order/helpers/formatCargo'
import { OrderCargoInfo } from 'src/schema'

import { OrderCargoBlockProps } from './types'

import s from './OrderCargoBlock.module.less'

export const OrderCargoBlock: FC<OrderCargoBlockProps> = (props) => {
  const { cargoType, cargo, cargoTotal, isLoading, handleOpenModalCargo, handleSetCargoTariffType } = props
  const navigate = useNavigate()

  return (
    <div data-test-id="order--cargo--block">
      <div className={cn('mt-4', s.cargoBodyBlock)}>
        {cargo && cargoType === OrderCargoInfo.type.SEPARATE
          ? cargo.map((el, index) => (
              <div key={index} className={cn(s.cargoSeparateBlock, 'max-w-xl')}>
                <div className={s.blockHeader}>
                  {!isLoading ? (
                    <h2 className={s.innerTitle}>{`Место №${index + 1}`}</h2>
                  ) : (
                    <PlaceholderCell className={cn(s.skeletonRow, s.skeletonRow_title)} height={20} />
                  )}
                </div>
                <div className={s.blockBody}>
                  <div className={s.cargoDescription}>
                    <div className={s.cargoRow}>
                      {!isLoading ? (
                        <>
                          <div className={s.cargoLabel}>Описание груза</div>
                          <div className={s.cargoContent}>{el.about}</div>
                        </>
                      ) : (
                        <PlaceholderCell className={cn(s.skeletonRow)} height={25} />
                      )}
                    </div>
                    <div className={s.cargoRow}>
                      {!isLoading ? (
                        <>
                          <div className={s.cargoLabel}>Оценочная стоимость</div>
                          <div className={s.cargoContent}>{getFormattedPriceWithRouble(el.price)}</div>
                        </>
                      ) : (
                        <PlaceholderCell className={cn(s.skeletonRow)} height={25} />
                      )}
                    </div>
                    <div className={s.cargoRow}>
                      {!isLoading ? (
                        <>
                          <div className={s.cargoLabel}>
                            Тариф (
                            <a
                              className="link cursor-pointer"
                              href="#"
                              onClick={(event) => {
                                event.preventDefault()
                                handleOpenModalCargo()
                                handleSetCargoTariffType(el?.type.id)
                                navigate({ hash: el?.type.id })
                              }}
                            >
                              условия
                            </a>
                            )
                          </div>
                          <div className={s.cargoContent}>{el.type.name}</div>
                        </>
                      ) : (
                        <PlaceholderCell className={cn(s.skeletonRow)} height={25} />
                      )}
                    </div>
                  </div>
                  <div className={s.divider}></div> {/* eslint-disable-line */}
                  <div className={s.cargoDescription}>
                    <div className={s.cargoRow}>
                      {!isLoading ? (
                        <>
                          <div className={s.cargoLabel}>Габариты (ДхШхВ)</div>
                          <div className={s.cargoContent}>{formatCargoSizeSeparate(el)}</div>
                        </>
                      ) : (
                        <PlaceholderCell className={cn(s.skeletonRow)} height={25} />
                      )}
                    </div>
                    <div className={s.cargoRow}>
                      {!isLoading ? (
                        <>
                          <div className={s.cargoLabel}>Вес</div>
                          <div className={s.cargoContent}>{formatCargoWeightGramToKilogram(el.weight)}</div>
                        </>
                      ) : (
                        <PlaceholderCell className={cn(s.skeletonRow)} height={25} />
                      )}
                    </div>
                    {el.packingType && (
                      <div className={s.cargoRow}>
                        {!isLoading ? (
                          <>
                            <div className={s.cargoLabel}>Тип упаковки</div>
                            <div className={s.cargoContent}>{el.packingType}</div>
                          </>
                        ) : (
                          <PlaceholderCell className={cn(s.skeletonRow)} height={25} />
                        )}
                      </div>
                    )}
                    {el.packingCondition && (
                      <div className={s.cargoRow}>
                        {!isLoading ? (
                          <>
                            <div className={s.cargoLabel}>Состояние упаковки</div>
                            <div className={s.cargoContent}>{el.packingCondition}</div>
                          </>
                        ) : (
                          <PlaceholderCell className={cn(s.skeletonRow)} height={25} />
                        )}
                      </div>
                    )}
                  </div>
                  {el.amount !== 1 ? (
                    <>
                      <div className={s.divider}></div> {/* eslint-disable-line */}
                      <div className={s.cargoDescription}>
                        <div className={s.cargoRow}>
                          {!isLoading ? (
                            <>
                              <div className={cn(s.cargoLabel, s.cargoBold)}>Всего таких мест</div>
                              <div className={cn(s.cargoContent, s.cargoBold)}>{`× ${el.amount}`}</div>
                            </>
                          ) : (
                            <PlaceholderCell className={cn(s.skeletonRow)} height={25} />
                          )}
                        </div>
                      </div>
                    </>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            ))
          : ''}
        {cargoTotal && cargoType === OrderCargoInfo.type.TOTAL ? (
          <div className={s.cargoTotalBlock}>
            <div className={cn(s.blockBody, s.nopt)}>
              <div className={s.cargoDescription}>
                <div className={s.cargoRow}>
                  {!isLoading ? (
                    <>
                      <div className={s.cargoLabel}>Описание груза</div>
                      <div className={s.cargoContent}>{cargoTotal.about}</div>
                    </>
                  ) : (
                    <PlaceholderCell className={cn(s.skeletonRow)} height={25} />
                  )}
                </div>
                <div className={s.cargoRow}>
                  {!isLoading ? (
                    <>
                      <div className={s.cargoLabel}>Оценочная стоимость</div>
                      <div className={s.cargoContent}>{getFormattedPriceWithRouble(cargoTotal.price)}</div>
                    </>
                  ) : (
                    <PlaceholderCell className={cn(s.skeletonRow)} height={25} />
                  )}
                </div>
                <div className={s.cargoRow}>
                  {!isLoading ? (
                    <>
                      <div className={s.cargoLabel}>
                        Тариф (
                        <a
                          className="link cursor-pointer"
                          href="#"
                          onClick={(event) => {
                            event.preventDefault()
                            handleOpenModalCargo()
                            handleSetCargoTariffType(cargoTotal?.type.id)
                            navigate({ hash: cargoTotal?.type.id })
                          }}
                        >
                          условия
                        </a>
                        )
                      </div>
                      <div className={s.cargoContent}>{cargoTotal.type.name}</div>
                    </>
                  ) : (
                    <PlaceholderCell className={cn(s.skeletonRow)} height={25} />
                  )}
                </div>
              </div>
              <div className={s.divider}></div> {/* eslint-disable-line */}
              <div className={s.cargoDescription}>
                <div className={s.cargoRow}>
                  {!isLoading ? (
                    <>
                      <div className={s.cargoLabel}>Самое длинное</div>
                      <div className={s.cargoContent}>{cargoTotal.length} см</div>
                    </>
                  ) : (
                    <PlaceholderCell className={cn(s.skeletonRow)} height={25} />
                  )}
                </div>
                <div className={s.cargoRow}>
                  {!isLoading ? (
                    <>
                      <div className={s.cargoLabel}>Самое широкое</div>
                      <div className={s.cargoContent}>{cargoTotal.width} см</div>
                    </>
                  ) : (
                    <PlaceholderCell className={cn(s.skeletonRow)} height={25} />
                  )}
                </div>
                <div className={s.cargoRow}>
                  {!isLoading ? (
                    <>
                      <div className={s.cargoLabel}>Самое высокое</div>
                      <div className={s.cargoContent}>{cargoTotal.height} см</div>
                    </>
                  ) : (
                    <PlaceholderCell className={cn(s.skeletonRow)} height={25} />
                  )}
                </div>
              </div>
              <div className={s.divider}></div> {/* eslint-disable-line */}
              <div className={s.cargoDescription}>
                <div className={s.cargoRow}>
                  {!isLoading ? (
                    <>
                      <div className={s.cargoLabel}>Общий вес</div>
                      <div className={s.cargoContent}>{formatCargoWeightGramToKilogram(cargoTotal.weight)}</div>
                    </>
                  ) : (
                    <PlaceholderCell className={cn(s.skeletonRow)} height={25} />
                  )}
                </div>
                <div className={s.cargoRow}>
                  {!isLoading ? (
                    <>
                      <div className={s.cargoLabel}>Общий объём</div>
                      <div className={s.cargoContent}>{formatCargoVolume(cargoTotal.volume)}</div>
                    </>
                  ) : (
                    <PlaceholderCell className={cn(s.skeletonRow)} height={25} />
                  )}
                </div>
              </div>
              <div className={s.divider}></div> {/* eslint-disable-line */}
              <div className={s.cargoDescription}>
                <div className={s.cargoRow}>
                  {!isLoading ? (
                    <>
                      <div className={cn(s.cargoLabel, s.cargoBold)}>Всего позиций</div>
                      <div className={cn(s.cargoContent, s.cargoBold)}>{`${cargoTotal.amount} мест`}</div>
                    </>
                  ) : (
                    <PlaceholderCell className={cn(s.skeletonRow)} height={25} />
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  )
}
